<template>
  <Modal
    v-model="$store.state.public.showPosterModal"
    :footer-hide="true"
    :closable="false"
    width="300px"
    class-name="poster-modal-wrapper"
    @on-visible-change="onOnVisibleChange"
  >
    <div class="poster-modal">
      <img :src="poster" style="width: 100%" />
      <img
        @click="onOnVisibleChange(false)"
        class="close-btn"
        src="data:image/png;base64,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"
      />
    </div>
  </Modal>
</template>

<script>
export default {
  props: {
    poster: {
      type: String,
      default: "",
    },
  },
  methods: {
    onOnVisibleChange(e) {
      this.$store.commit("public/SET_POSTER_VISIABLE", e);
    },
  },
};
</script>

<style lang="less" scoped>
.poster-modal {
  position: relative;
  width: 300rpx;
  .close-btn {
    position: absolute;
    width: 30px;
    height: 30px;
    top: -20px;
    right: -50px;
  }
}
</style>

<style lang="less">
.poster-modal-wrapper {
  .ivu-modal-content {
    background-color: transparent;
    box-shadow: none;
  }
}
</style>
